import { visit } from 'unist-util-visit';
import { Checkbox } from '../../../generalComponents/Checkbox/Checkbox';
import { checkedButton } from '../../../../utils';
import { CodeBlockHeader } from '../../../generalComponents/CodeBlockHeader/CodeBlockHeader';
import { ChatButtonBody } from '../../../generalComponents/Buttons/ChatButtonBody';
import { QuestionButton } from '../../../generalComponents/Buttons/QuestionButton';
import { v4 } from 'uuid';
import React, {useMemo} from "react";
import {logDebug, logError, logInfo, logWarning} from "../../../../utils/logger";
import ChartsContainer from "../../../generalComponents/Chart/ChartsContainer";

let langName = 'unknown'; // Default value
let getCode = (codeObj: any) => {
  let result = codeObj.children;
  let textPart = "";
  for (let i = 0; i < result.length; i++) {
    if (result[i].type === "text") {
      textPart += result[i].value;
    } else {
      textPart += getCode(result[i]);
    }
  }
  return textPart;
}


export function actionQuestionPlugin(options: { ActionString: string }) {
  return (tree: any) => {
    visit(tree, 'html', (node, index, parent) => {
      const value = node.value;
      logInfo("actionQuestionPlugin:", value);
      // Detect `<chart>` tags
      // if (value.toLowerCase().includes("chart") && index !== undefined) {
      //   logDebug(`Chart tag detected at index ${index}, replacing with ChartsContainer`);
      //
      //   // Debug the element before replacement
      //   logDebug("Before replacement:", JSON.stringify(parent.children[index], null, 2));
      //
      //   const chartProps = {}; // Extract or define any necessary props for ChartsContainer
      //   parent.children.splice(index, 1, {
      //     type: 'element',
      //     tagName: 'ChartsContainer',
      //     properties: chartProps,
      //     children: [],
      //   });
      //
      //   // Debug the element after replacement
      //   logDebug("After replacement:", JSON.stringify(parent.children[index], null, 2));
      //
      //   // Debug full parent structure after modification
      //   logDebug("Updated parent children structure:", JSON.stringify(parent.children, null, 2));
      // }


      // Handling <action> tags
      if (value === '<action>' && index) {
        const contentNode = parent.children[index + 1];
        const closingNode = parent.children[index + 2];

        if (contentNode && contentNode.type === 'text' && closingNode && closingNode.value === '</action>') {
          const actionContent = contentNode.value;

          parent.children.splice(index, 3, {
            type: 'element',
            tagName: 'div',
            children: [{ type: 'text', value: "actCont " + actionContent }],
          });
        }
      }
      if (value === '<question>' && index) {
        const contentNode = parent.children[index + 1];
        const closingNode = parent.children[index + 2];

        if (contentNode && contentNode.type === 'text' && closingNode && closingNode.value === '</question>') {
          const questionContent = contentNode.value;

          const nextNode = parent.children[index + 3];
          const lastQuestion = !nextNode;
          parent.children.splice(index, 3, {
            type: 'element',
            tagName: 'div',
            children: [{ type: 'text', value: (lastQuestion ? "lastQuestCont " : "questCont ") + questionContent }],
          });
        }
      }

          if (value.includes('advanced_real_time_chart') && index) {
            logInfo('Found advanced_real_time_chart tag');
          parent.children.splice(index, 1, {
            type: 'div',
            tagName: 'img', // Replace 'yourElement' with the desired element tag name
            children: [],
          });
        }

      // Handling <img> tags
      // if (value && value.startsWith('<img')) {
      //   const srcMatch = value.match(/src="([^"]+)"/);
      //   const altMatch = value.match(/alt="([^"]+)"/);
      //
      //   const src = srcMatch ? srcMatch[1] : '';
      //   const alt = altMatch ? altMatch[1] : '';
      //
      //   // Replace <img> tag with a div containing the image as a background or as an <img> tag itself
      //   parent.children.splice(index, 1, {
      //     type: 'element',
      //     tagName: 'div',
      //     properties: {
      //       style: `background-image: url(${src}); width: 100%; height: 100%; background-size: cover; background-position: center;`
      //     },
      //     children: [
      //       { type: 'text', value: alt }
      //     ]
      //   });
      // }

      if (parent && parent.children) {
        parent.children.forEach((child: any) => {
          if (child.type === 'text' && child.value.includes('custom123tag321qazxsw')) {
            child.value = child.value.replace('custom123tag321qazxsw', '');
          }
        });
      }
    });
  };
}

export const componentsContainer = (questionHandler?: (questionText: string) => void, load?: boolean) => {
  const listLetters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'];
  let currentListLetters = -1;
  logInfo("componentsContainer");
  const components: Record<string, React.ElementType> = {
    input: ({ ...props }) => {
      if (props.type === 'checkbox' && props.checked) {
        return (
          <Checkbox
            checked={props.checked}
            handleChecked={() => { }}
            checkedButtonImg={checkedButton}
          />
        );
      }
      return <input {...props} id={v4()} />;
    },
    li: ({ children }) => {
      if (!children) {
        return null;
      }
      if (Array.isArray(children) && children.length) {
        return (
          <li>
            {children[0]}
            <span>{children.slice(1)}</span>
          </li>
        );
      }
      return (
        <li>
          {children}
        </li>
      );
    },
    pre: ({ node, children, ...props }) => {
      const codeNode = node.children[0];

      try {
        const className = codeNode.properties.className || [];
        const langClass = className.length > 1 ? className[1] : '';
        langName = langClass.replace('language-', '').trim(); // Remove 'language-' and trim whitespace

        // Verify the extracted language name
        if (langName === '') {
          logWarning('No language name extracted.');
        }
      } catch (error) {
        logError('Error extracting language name:', error);
        // You could set a fallback language name here if desired
      }
      const code = getCode(codeNode);

      return (
        <pre>
          <CodeBlockHeader langName={langName} code={code} />
          <div className='codeWrapper'>
            {children}
          </div>
        </pre>
      );
    },
    div: ({ children }) => {
      if (typeof children === "string") {
          // if (children.includes("chart")) {
          //   return <ChartsContainer />;
          // }
          // if (children.includes("advanced_real_time_chart")) {
          //   return <ChartsContainer />;
          // }
        if (children.includes("actCont")) {
          const content = children.replace("actCont ", "");
          return <ChatButtonBody displayEnter={false} regenerateResponse={() => { logDebug(`Action ${content} done!`) }} btnText={content} additionalStyle={{ marginTop: 8 }} />
        }
        if (children.includes("questCont") || children.includes("lastQuestCont")) {
          if (children.includes("lastQuestCont")) {
            let last = currentListLetters + 1;
            currentListLetters = -1;
            return <QuestionButton listText={listLetters[last]} questionText={children.replace("lastQuestCont ", "")} buttonHandler={questionHandler} load={load} />
          }
          const content = children.replace("questCont ", "");
          currentListLetters++;
          return <QuestionButton listText={listLetters[currentListLetters]} questionText={content} buttonHandler={questionHandler} load={load} />
        }
      }
      return <div>{children}</div>
    },
// advanced_real_time_chart: ({ children, ...props }) => {
//   logDebug("Rendering advanced_real_time_chart with props:", props);
//   return <div className="chartWrapper"><ChartsContainer {...props} /></div>;
// },
  };
  return components;
}


export function replaceUnicodeSymbols() {
  return (tree: any) => {
    visit(tree, 'text', (node) => {
      node.value = node.value.replace(/\\u0022/g, '"')
        .replace(/\\u0027/g, "'");
    });
  };
}